import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ---------------------------------------------------------------------------
// 启动信息：在浏览器控制台打印域名 / API 配置，方便排查跨域问题
// ---------------------------------------------------------------------------
(() => {
  const rawApiUrl = process.env.REACT_APP_API_URL ?? '';
  let apiBase = rawApiUrl.trim();
  let currentOrigin = '';
  if (typeof window !== 'undefined' && window.location) {
    currentOrigin = window.location.origin;
  }
  // 空值或仅斜杠 => 相对路径（同源）
  const isRelative = !apiBase || apiBase.startsWith('/');
  if (isRelative) {
    // 显示实际会请求到的完整 URL（同源）
    apiBase = currentOrigin + (apiBase.startsWith('/') ? apiBase : '/api');
  } else if (apiBase.endsWith('/')) {
    apiBase = apiBase.slice(0, -1);
  }
  const sameOrigin = currentOrigin && apiBase.startsWith(currentOrigin);

  // 分组输出，F12 默认可见
  const groupLabel = '%c[易成标AI] 启动环境信息';
  console.groupCollapsed(groupLabel, 'color:#2563eb;font-weight:bold');
  console.log('%c页面访问地址 (当前 Origin):', 'color:#0e9f6e;font-weight:bold', currentOrigin || '(未知)');
  console.log('%cAPI 请求基础地址 (REACT_APP_API_URL):', 'color:#0e9f6e;font-weight:bold', apiBase);
  console.log('%c.env 原始值:              ', 'color:#0e9f6e;font-weight:bold', rawApiUrl || '(留空=相对路径)');
  console.log('%c请求策略:                 ', 'color:#0e9f6e;font-weight:bold',
    sameOrigin ? '同源 (不触发 CORS)' : '跨域 (依赖后端 CORS 白名单)');
  if (!sameOrigin) {
    const a = document.createElement('a');
    a.href = apiBase;
    const apiOrigin = a.origin;
    console.log('%cAPI 端 Origin (后端域名):  ', 'color:#c53030;font-weight:bold', apiOrigin);
    console.log(
      '%c⚠ CORS 依赖: ',
      'color:#c53030;font-weight:bold',
      `后端 CORS_ORIGINS 必须允许 Origin=${currentOrigin}，`
      + `若当前使用通配符 https://*.ksmso.cn，则所有 ksmso.cn 子域名自动通过；`
      + `否则需要将 ${currentOrigin} 加入白名单。`
    );
    // 给一个后端 log 里对应的示例检查点
    console.log('%c后端启动日志检查点:       ', 'color:#b45309;font-weight:bold',
      `"跨域命中示例: ${(currentOrigin || 'https://xxx.ksmso.cn').replace(/^https?:\/\//, '')}  -> true"`);
  } else {
    console.log('%c✓ 同源策略：无需后端 CORS 配置', 'color:#0e9f6e;font-weight:bold');
  }
  console.log('%c构建时间 / 版本:           ', 'color:#64748b',
    process.env.NODE_ENV || 'production',
    process.env.REACT_APP_VERSION || ''
  );
  console.groupEnd();

  // 总是单独输出一条摘要，避免用户没展开分组时完全看不到
  console.log(
    '%c[易成标AI]',
    'color:#2563eb;font-weight:bold',
    `页面=${currentOrigin || '?'} | API=${apiBase} | ${sameOrigin ? '同源' : '跨域(' + currentOrigin + '->' + (() => {
      try { return (new URL(apiBase)).origin; } catch { return '?'; }
    })() + ')'}`
  );
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
